import {
  AfterViewChecked,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { HighlightService } from 'src/app/core/services/highligh.service';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

const cdnUrl: string = environment.cdnUrl;

const defaults = {
  css_cdn:
    `<!-- css BDC -->
<link href="` +
    cdnUrl +
    `all.css" rel="stylesheet">`,
  'utils.js':
    `<!-- utils.js BDC -->
<script src="` +
    cdnUrl +
    `script.js"></script>`,
  css_bootstrap: `<!-- css bootstrap -->
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
rel="stylesheet" crossorigin="anonymous">`,
  js_bootstrap: `<!-- js bootstrap -->
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js"
integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM"
crossorigin="anonymous"></script>`,
};

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InicioComponent implements OnInit, AfterViewChecked {
  title: string = 'BDC_GOV.CO V.5.0';
  description: string =
    "<span class='Nunito-Sans-Bold'>¡Bienvenidos!</span> La Biblioteca Digital de Componentes (BDC), en su versión 5 (v.5), permite a las entidades implementar en sus sitios webs los estándares del Portal Único del Estado Colombiano (www.gov.co) de una manera más ágil y práctica.";

  highlighted: boolean = false;

  defaults = defaults;
  public urlComponent = 'home';
  public fuenteIconografica = "https://gitlab.com/govco/layout-govco/-/blob/v5/src/assets/icons/fonts/gov-co-font.ttf";

  public kitUX_url: string =
    'https://govco-prod-webutils.s3.amazonaws.com/uploads/2022-12-16/93260448-a670-4445-a9f7-6bbde8c0ec75-Guia-para-la-implementacio%CC%81n-de-usabilidad.pdf';
  public kitUX_urlPDF: string =
    'https://govco-prod-webutils.s3.amazonaws.com/uploads/2022-12-16/93260448-a670-4445-a9f7-6bbde8c0ec75-Guia-para-la-implementacio%CC%81n-de-usabilidad.pdf';
  public kitAX_url: string =
    'https://govco-prod-webutils.s3.amazonaws.com/uploads/2022-11-10/9c1fd508-005a-4f44-b3f5-431506811691-Guia_para_la_implementacion_de_accesibilidad_web-v2%20(1).pdf';
  public kitAX_urlPDF: string =
    'https://govco-prod-webutils.s3.amazonaws.com/uploads/2022-11-10/9c1fd508-005a-4f44-b3f5-431506811691-Guia_para_la_implementacion_de_accesibilidad_web-v2%20(1).pdf';
  public kitUI_url: string = 'https://das997q1qk8hr.cloudfront.net/uploads/2025-10-09/65142f4c-971a-4e15-bf29-c11ade54ac20-kit-ui-9-2.pdf';
  public kitUI_urlPDF: string = 'https://das997q1qk8hr.cloudfront.net/uploads/2025-10-09/65142f4c-971a-4e15-bf29-c11ade54ac20-kit-ui-9-2.pdf';

  public content = [
    {
      id: 'bdc_gov.co-v.5.0',
      nombre: 'Inicio',
    },
    {
      id: 'conoce',
      nombre: 'Conoce la nueva versión V.5.0',
    },
    {
      id: 'integra',
      nombre: '¿Cómo integrarse al Portal Único del Estado Colombiano?',
    },
    {
      id: 'como-empezar',
      nombre: '¿Cómo empezar?',
      subItems: [
        {
          id: 'instalacion',
          nombre: 'Instalación',
        },
        {
          id: 'dependencia',
          nombre: 'Dependencias',
        },
      ],
    },
    {
      id: 'ventajas',
      nombre: 'Ventajas',
    },
    {
      id: 'kit-herramientas-integracion',
      nombre: 'Kit de herramientas para integración',
    },
  ];
  constructor(
    private highlightService: HighlightService,
    private titleHeader: Title
  ) {}

  ngOnInit(): void {
    this.titleHeader.setTitle(
      'Biblioteca Digital de Componentes de integración - Versión 4'
    );
  }
  /**
   * Highlight blog post when it's ready
   */
  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }
}
